import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { ApiResource } from './../../models/api-resource.interface';
import { InternalJobFunction } from './internal-job-function.interface';
import { InternalJobFunctionService } from './internal-job-function.service';
const service = new InternalJobFunctionService();

export interface InternalJobFunctionState {
   internalJobFunctionsOverview?: ApiResource<Array<InternalJobFunction>>;
}

const InternalJobFunctionStore: Module<InternalJobFunctionState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {
      internalJobFunctionsOverview: (state) => state.internalJobFunctionsOverview,
   },
   mutations: {
      SET_INTERNAL_JOB_FUNCTIONS_OVERVIEW(state, internalJobFunctionsOverview: ApiResource<Array<InternalJobFunction>>) {
         state.internalJobFunctionsOverview = internalJobFunctionsOverview;
      },
      ADD_INTERNAL_JOB_FUNCTION(state, internalJobFunction: InternalJobFunction) {
         if (!state.internalJobFunctionsOverview?.data) return;
         state.internalJobFunctionsOverview.data.push(internalJobFunction);
      },
      SET_INTERNAL_JOB_FUNCTION(state, internalJobFunction: InternalJobFunction) {
         const index = (state.internalJobFunctionsOverview?.data || []).findIndex((ijf) => ijf.id === internalJobFunction.id);
         if (index > -1) state.internalJobFunctionsOverview?.data.splice(index, 1, internalJobFunction);
      },
      REMOVE_INTERNAL_JOB_FUNCTION(state, internalJobFunctionId: number) {
         const index = (state.internalJobFunctionsOverview?.data || []).findIndex((ijf) => ijf.id === internalJobFunctionId);
         if (index > -1) state.internalJobFunctionsOverview?.data.splice(index, 1);
      },
   },
   actions: {
      async searchInternalJobFunctions(context, query?: LocationQuery) {
         const response = await service.getInternalJobFunctions({
            'filter[name]': query?.search ?? '',
            ...query,
            per_page: '100',
            page: '1',
         });
         return response.data;
      },
      async getInternalJobFunctions(context, query?: LocationQuery) {
         const internalJobFunctionsOverview = await service.getInternalJobFunctions(query);
         context.commit('SET_INTERNAL_JOB_FUNCTIONS_OVERVIEW', internalJobFunctionsOverview);
         return internalJobFunctionsOverview;
      },
      async createInternalJobFunction(context, internalJobFunction: InternalJobFunction) {
         const response = await service.postInternalJobFunction(internalJobFunction);
         context.commit('ADD_INTERNAL_JOB_FUNCTION', response);
         return response;
      },
      async changeInternalJobFunction(context, payload: { internalJobFunctionId: number; internalJobFunction: InternalJobFunction }) {
         const response = await service.putInternalJobFunction(payload.internalJobFunctionId, payload.internalJobFunction);
         context.commit('SET_INTERNAL_JOB_FUNCTION', response);
         return response;
      },
      async removeInternalJobFunction(context, internalJobFunctionId: number) {
         const response = await service.deleteInternalJobFunction(internalJobFunctionId);
         context.commit('REMOVE_INTERNAL_JOB_FUNCTION', internalJobFunctionId);
         return response;
      },
   },
};

export default InternalJobFunctionStore;
